/**
 * @name            MakeHuman
 * @copyright       MakeHuman Team 2001-2016
 * @license         [AGPL3]{@link http://www.makehuman.org/license.php}
 * @description     entry point
 */
export * from './human'
export * from './proxy'
export * from './targets'
export * from './human-modifier'
export * from './ethnic-skin-blender'
export * from './factors'



// WEBPACK FOOTER //
// ./src/js/human/index.js